import {Component} from 'react';
// import {bindActionCreators} from 'redux';
// import {connect} from 'react-redux';
// import tCommonActions from 'Actions/common';

export default class UnionComponent extends Component {
  // 设置table loading
  setTableListLoading = () => {
    const {tableListLoading} = this.state;

    this.setState({
      tableListLoading: !tableListLoading,
    });
  };

  // 获取table列表数据
  getTableList = (values, type) => {
    const {actions} = this.props;
    if (type !== 'withoutLoading') {
      this.setTableListLoading();
    }
    actions.getTableList(values).finally(() => {
      this.setTableListLoading();
    });
  };

  // 获取定制化table列表数据
  getCustomizeTableList = (values, type) => {
    const {actions} = this.props;
    const customize = localStorage.getItem('customize');

    if (type !== 'withoutLoading') {
      this.setTableListLoading();
    }
    if (customize === 'txgg') {
      actions.getCustomizeTableList(values).finally(() => {
        this.setTableListLoading();
      });
    } else {
      actions.getTableList(values).finally(() => {
        this.setTableListLoading();
      });
    }
  };
}
